import React from 'react';
import { StyledChatItem } from './ChatItem.style';
import { getImageUrlByPath } from '@/Services/Image';
import Image from '@/Components/atoms/Image';
import { IOfferedSellProductDto } from '@/Models/Chat';
import { useTranslation } from 'next-i18next';

type Props = {
  item: IOfferedSellProductDto;
  onSelect?: (id: number) => void;
  showOfferCount?: boolean;
};

const ChatSellItem = ({ item, onSelect, showOfferCount = true }: Props) => {
  const { t } = useTranslation();

  const onClick = () => {
    onSelect && onSelect(item.id);
  };

  return (
    <StyledChatItem className='chat-item' onClick={onClick}>
      <div className='chat-item__inner'>
        <div className='chat-item__img-wrapper'>
          <Image className='chat-item__img' src={getImageUrlByPath(item.imagePath, 200, 200)} alt='' />
        </div>
        <div className='chat-item__text-wrapper'>
          <div className='chat-item__title-wrapper'>
            <h5 className='chat-item__title'>{item.name}</h5>
            {/* <span className='chat-item__date'>
              { DateService.toHHMM(item.createdAt) }
            </span> */}
          </div>
          <div className='chat-item__description-wrapper'>
            <p className='chat-item__description'>{showOfferCount ? t('number_of_offers', { key: item.totalOffersCount }) : item.description}</p>
            {item.unreadOffersCount > 0 && <span className='chat-item__newMessageCount'>{item.unreadOffersCount}</span>}
          </div>
        </div>
      </div>
    </StyledChatItem>
  );
};

export default ChatSellItem;
